import Utils from "../utils/utils"
const utilsHelper = new Utils()

export default class AutoCoupon{
    constructor(){
        this.expected_params = [
            "opt99-order-coupon", "order-coupon", "opt99-affiliate-code", "affiliate-code",
        ]
        this.url_params = {
            "old-order-coupon": "order-coupon",
            "order-coupon": "opt99-order-coupon",
            "old-affiliate-code": "affiliate-code",
            "affiliate-code": "opt99-affiliate-code"
        } 
        this.retry_time = 5
    }

    run(current_url) {
        console.log('current_url', current_url)

        let isActivateCoupon = localStorage.getItem('isActivateCoupon')

        if (isActivateCoupon === '0') {
            console.log('coupon_not_supported')
            return
        }

        // 存網址的圖卡變數
        this.getParams(current_url, this.expected_params)

        // 判斷是哪家電商
        const platform = utilsHelper.checkPlatform()

        let is_activate_coupon = this.isActivateCoupon(platform, current_url)
        console.log('is_activate_coupon: ', is_activate_coupon)
        let is_activate_acode = this.isActivateAffiliateCode(platform, current_url)
        console.log('is_activate_acode: ', is_activate_acode)

        // 符合自動帶入優惠券/推薦碼的頁面
        if (is_activate_coupon) {
            // 自動帶入優惠券代碼
            let coupon_id = this.getSpecificParam(this.url_params['order-coupon'])
            if (!coupon_id) {
                coupon_id = this.getSpecificParam(this.url_params['old-order-coupon'])
            }
            this.autoFillCoupon(coupon_id, platform, current_url)
        }

        if (is_activate_acode) {
            // 自動帶入推薦代碼
            let a_code = this.getSpecificParam(this.url_params['affiliate-code'])
            if (!a_code) {
                a_code = this.getSpecificParam(this.url_params['old-affiliate-code'])
            }
            this.autoFillAffiliateCode(a_code, platform)
        }

    }

    getParams(current_url, expected_params) {
        let url = new URL(current_url)
        let host_name = window.location.hostname;
        let from_url = document.referrer;
        let is_from_other_site = from_url.indexOf(host_name) === -1

        expected_params.forEach(function(expected_param){

            if (url.searchParams.get(expected_param)) {
                localStorage.setItem(expected_param, url.searchParams.get(expected_param))
                sessionStorage.setItem(expected_param, url.searchParams.get(expected_param));
                let s_code_param = sessionStorage.getItem(expected_param)
                console.log(`s_code_param_${expected_param}`,s_code_param)
            }
            // url沒有變數的話判斷sessionStorage
            else {
                let s_code_param = sessionStorage.getItem(expected_param)
                if (is_from_other_site) {
                    if (s_code_param) {
                        localStorage.setItem(expected_param, s_code_param)
                        sessionStorage.removeItem(expected_param)
                    }
                    else {
                        localStorage.removeItem(expected_param)
                    }
                }
                else {
                    let l_code_param = localStorage.getItem(expected_param)
                    if (!s_code_param && l_code_param) {
                        sessionStorage.setItem(expected_param, l_code_param)
                    }
                }

            }
        })

    }

    getSpecificParam(name) { 
        return localStorage.getItem(name)
    }

    isActivateCoupon(platform, current_url){
        let url = new URL(current_url)
        let pathname = url.pathname
        let result = false
        switch (platform) {
            case 'shopline':
                if (pathname.indexOf('cart') !== -1) {
                    result = true
                }
                break;
            case 'cyberbiz':
                if (pathname.indexOf('carts') !== -1 || pathname.indexOf('/events/') !== -1) {
                    result = true
                }
                break;
            case '91app':
                if (pathname.indexOf('ShoppingCart') !== -1) {
                    result = true
                }
                break;
        }
        return result
    }

    isActivateAffiliateCode(platform, current_url){
        let url = new URL(current_url)
        let pathname = url.pathname
        let result = false
        switch (platform) {
            case 'shopline':
                if (pathname.indexOf('cart') !== -1) {
                    result = true
                }
                break;
            case 'cyberbiz':
                if (pathname.indexOf('carts') !== -1 || pathname.indexOf('/events/') !== -1) {
                    result = true
                }
                break;
            case '91app':
                if (pathname.indexOf('ShoppingCart') !== -1) {
                    result = true
                }
                break;
        }
        return result
    }

    async autoFillCoupon(code, platform, current_url){

        if (!code) {
            return
        }

        if (localStorage.getItem('reseller_cb_id')) {
            return
        }

        if (platform === 'shopline') {
            var xpath = '//span[contains(text(),"' + code +'")]';
            var coupon_ele = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
            //console.log(coupon_ele);
            if (coupon_ele !== null) {
              return
            }
           
            var coupon_field;
            coupon_field = document.getElementById('order-coupon');
      
            if (coupon_field === null) {
              return
            }
            coupon_field.value = code;
            coupon_field.nextElementSibling.click();
        }
        else if(platform === 'cyberbiz') {
            if (current_url.indexOf('events') !== -1) {
                let add_to_cart_btns = Array.from(document.getElementsByClassName('add-button'))

                if (add_to_cart_btns.length <= 0) {
                    document.addEventListener('click', function(event){
                        if (event && event.target.closest('.add-button')) {
                            setTimeout(() => {
                                let items = Array.from(document.querySelectorAll('.line-item'))
                                if (items.length > 0) {
                                    window.application.multipleCouponModal.state.couponCode = code
                                    window.application.multipleCouponModal.searchCoupon()
                                    window.application.multipleCouponModal.state.checkedCouponList = [code]
                                    window.application.multipleCouponModal.submitCoupons(window.application.couponDiscountBlock.props.priceValidations)
                                }
                            }, 3000)
                        }
                    }, true)
                }
                else {
                    add_to_cart_btns.forEach(function(btn){
                        btn.addEventListener('click', function(){
                          setTimeout(function(){
                            window.application.multipleCouponModal.state.couponCode = code
                            window.application.multipleCouponModal.searchCoupon()
                            window.application.multipleCouponModal.state.checkedCouponList = [code]
                            window.application.multipleCouponModal.submitCoupons(window.application.couponDiscountBlock.props.priceValidations)
                          }, 1300)
                        })
                    })
                }

            }
            else {
                for (let idx = 0 ; idx <= this.retry_time; idx++) {
                    if (window.application) {
                        window.application.multipleCouponModal.state.couponCode = code
                        window.application.multipleCouponModal.searchCoupon()
                        window.application.multipleCouponModal.state.checkedCouponList = [code]
                        window.application.multipleCouponModal.submitCoupons(window.application.couponDiscountBlock.props.priceValidations)
                        break;
                    }
                    else {
                        await utilsHelper.sleep(500);
                    }
                }

            }
        }
        else if(platform === '91app') {
            let element = document.querySelector('[class*="CouponTextButton"]');
            if (!element) {
                for (let idx = 0 ; idx <= this.retry_time; idx++) {
                    console.log('not_exist')
                    await utilsHelper.sleep(1200);
                    element = document.querySelector('[class*="CouponTextButton"]');
                    if (!element) {
                        continue
                    }
                    
                    break
                }
            }
            element.click()
            let code_input = document.getElementsByName('couponCode')[0]
            utilsHelper.setNativeValue(code_input, code)

            let search_btn = document.querySelector('[class*="SearchButton"]');
            search_btn.click()
        }
    }

    async autoFillAffiliateCode(code, platform){

        // 91沒有推薦碼功能

        if (platform === 'shopline') {
            if (!code) {
                return
            }
            var xpath = '//span[contains(text(),"' + code +'")]';
            var coupon_ele = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
            //console.log(coupon_ele);
            if (coupon_ele !== null) {
                return
            }
            
            var coupon_field;
            coupon_field = document.getElementById('affiliate-code-field');
        
            if (coupon_field === null) {
                return
            }
            coupon_field.value = code;
            coupon_field.nextElementSibling.click();

        }
        else if(platform === 'cyberbiz') {
            if (code) {
                let is_success = false
                for (let idx = 0 ; idx <= this.retry_time; idx++) {
                    if (window.applyAffiliateCode) {
                        console.log('code:', code)
                        window.applyAffiliateCode(code)
                        is_success = true
                        break;
                    }
                    else {
                        await utilsHelper.sleep(800);
                    }
                }
                if (!is_success) {
                    utilsHelper.setCookie('url_referral_code', code, 1)
                }
                
            }
            // utilsHelper.setCookie('url_referral_code', code, 1)
        }

    }

}